export type TypeEventHandler = (this: HTMLElement, evt: Event) => void;
export type TypeEventConfig = Record<string, TypeEventHandler | null | undefined>;

// ----------------------------------------------------------------------------

function create(element: HTMLElement, obj: TypeEventConfig): void {
    for (const [eventName, handler] of Object.entries(obj)) {
        if (typeof handler === 'function') {
            element.addEventListener(eventName, function (this: HTMLElement, evt: Event): any {
                handler.call(this, evt);
            });
        }
    }
}

// ----------------------------------------------------------------------------

export default create;
